import * as ActionTypes from 'constants/actionTypes'
import { apiClient } from 'lib';

import store from 'store'

export const fetch = async(params = {})=>{
  let response
  
  response = await apiClient.companies.fetch(params)

  const data = response.data.reduce((acc, item)=>{
    acc[item.id] = item
    return acc;
  }, {})

  store.dispatch({ 
    type: ActionTypes.FETCH_COMPANIES,
    payload: data
  })
}

export const update = async(params = {}) => {
   const response = await apiClient.companies.update(params)

  store.dispatch({
    type: ActionTypes.UPDATE_COMPANY,
    payload: response.data
  })

  return response.data
}

export const activate = async(ids = []) => {
  const response = await apiClient.companies.activate({ids})

  store.dispatch({
    type: ActionTypes.UPDATE_COMPANIES,
    payload: response.data
  })

  return response.data
}

export const destroy = async(id) => {
  await apiClient.companies.destroy(id)

  store.dispatch({
    type: ActionTypes.DESTROY_COMPANY,
    payload: id
  })
}

export const create = async(params = {}) => {
  const response = await apiClient.companies.create(params)

  store.dispatch({
    type: ActionTypes.CREATE_COMPANY,
    payload: response.data
  })

  return response.data
}

